import React__default, { createContext, useContext, useMemo } from 'react';

const DropdownContext = /*#__PURE__*/createContext({
  id: undefined,
  label: '',
  multiple: false
});
const DropdownContextProvider = ({
  id,
  label,
  multiple,
  children
}) => /*#__PURE__*/React__default.createElement(DropdownContext.Provider, {
  value: {
    id,
    label,
    multiple
  }
}, children);
const useDropdownContext = () => {
  const {
    id,
    label,
    multiple
  } = useContext(DropdownContext);
  const listboxProps = useMemo(() => ({
    role: 'listbox',
    'aria-multiselectable': multiple,
    ...(label && {
      ...(id ? {
        'aria-labelledby': id
      } : {
        'aria-label': label
      })
    })
  }), [id, label, multiple]);
  return {
    multiple,
    listboxProps
  };
};

export { DropdownContextProvider as D, useDropdownContext as u };
//# sourceMappingURL=DropdownContext-Cjb3JGE6.js.map
